// extracted by mini-css-extract-plugin
export var typingIndicator = "_ne-0";